// GENEROWANE z opisu linii w workerze Go: `worker tool typy` (worker-go/tools/typy).
// Nie edytować ręcznie - zmiana kontraktu = zmiana opisu w Go i ponowne wygenerowanie (KN-2).

import type { ViewDoc } from "../kontrakt";

export interface PolaPiec {
}

export interface NastawyPiec {
}

/** Stan procesu w widoku (`state`) - etykiety z opisu procesu linii. */
export type StanPiec = "AWARIA" | "PRACA" | "ROZPALANIE" | "WYGASZANIE" | "WYGASZONY";

export interface WidokPiec extends Omit<ViewDoc, "fields" | "settings" | "no_sensor" | "state"> {
  type: "piec";
  state?: StanPiec;
  fields: PolaPiec;
  settings?: NastawyPiec;
  no_sensor?: Array<keyof PolaPiec>;
}
/** Kanały wykresu (numer w próbkach i w punkcie na żywo `widok.wykres`) z nazwą domyślną z opisu linii. */
export const KANALY_PIEC = [
  {
    "idx": 0,
    "nazwa": "Kocioł",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 1,
    "nazwa": "CO",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 2,
    "nazwa": "CWU",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 3,
    "nazwa": "Zewnętrzna",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 4,
    "nazwa": "Spaliny",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 5,
    "nazwa": "Podajnik",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 6,
    "nazwa": "Nadmuch %",
    "ukryty": true,
    "zimny": false
  },
  {
    "idx": 7,
    "nazwa": "Nastawa",
    "ukryty": false,
    "zimny": false
  },
  {
    "idx": 8,
    "nazwa": "Ciśnienie",
    "ukryty": true,
    "zimny": false
  },
  {
    "idx": 9,
    "nazwa": "Δ spaliny °C/min",
    "ukryty": true,
    "zimny": false
  },
  {
    "idx": 10,
    "nazwa": "Paliwo %",
    "ukryty": true,
    "zimny": false
  },
  {
    "idx": 11,
    "nazwa": "Spalanie kg/h",
    "ukryty": true,
    "zimny": false
  },
  {
    "idx": 12,
    "nazwa": "Zużycie kg (doba)",
    "ukryty": true,
    "zimny": false
  }
] as const;

